import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ByAssigned } from "../../../../model/filters/by-assigned";
import { ByBranch } from "../../../../model/filters/by-branch";
import { ByDepartment } from "../../../../model/filters/by-department";
import { ById } from "../../../../model/filters/by-id";
import { ByPriority } from "../../../../model/filters/by-priority";
import { ByRegistered } from "../../../../model/filters/by-registered";
import { ByStatus } from "../../../../model/filters/by-status";
import { ByTitle } from "../../../../model/filters/by-title";
import { Newest } from "../../../../model/filters/newest";

import { NavigationHelper } from "../../../../services/navigation.helper";
import { BehaviorSubject } from "rxjs";
import { FilterService } from "../../../../services/filter.service";
import { Active } from "../../../../model/filters/active";
import { Archived } from "../../../../model/filters/archived";

@Component({
  selector: "filter-form",
  templateUrl: "./filter-form.component.html",
  styleUrls: ["./filter-form.component.css"],
})
export class FilterFormComponent implements OnInit {
  filterSelected: BehaviorSubject<any> = new BehaviorSubject(Newest.DEFAULT);
  filterCode: BehaviorSubject<string> = new BehaviorSubject("");
  selectedFilter: ById = new ById(0);

  constructor(
    private nav: NavigationHelper,
    private filterService: FilterService
  ) {}

ngOnInit(): void {
  this.nav.fragmentTopics.subscribe((topic) => {
    const code = topic?.trim() || "";
    if (code && code.length > 0) {
      this.filterCode.next(code);
      this.setFilterByCode(code);
    } else {
      this.noFilterSelected();
    }
  });

}



private setFilterByCode(code: string): void {
  switch (code) {
    case "by.assigned":
      this.filterSelected.next(new ByAssigned(this.selectedFilter.id));
      break;
    case "by.branch":
      this.filterSelected.next(new ByBranch(this.selectedFilter.id));
      break;
    case "by.department":
      this.filterSelected.next(new ByDepartment(this.selectedFilter.id));
      break;
    case "by.id":
      this.filterSelected.next(new ById(this.selectedFilter.id));
      break;
    case "by.priority":
      this.filterSelected.next(new ByPriority(this.selectedFilter.id));
      break;
    case "by.registered":
      this.filterSelected.next(new ByRegistered(this.selectedFilter.id));
      break;
    case "by.status":
      const statusId = Number(this.nav.current.fragmentId) || 0;
      this.filterSelected.next(new ByStatus(statusId));
      break;
    case "by.title":
      this.filterSelected.next(new ByTitle(""));
      break;
    case "active":
      this.filterSelected.next(new Active());
      break;
    case "archived":
      this.filterSelected.next(new Archived());
      break;
    case "newest":
      this.filterSelected.next(Newest.DEFAULT);
      break;
    default:
      this.filterSelected.next(Newest.DEFAULT);
      break;
  }
}

  private noFilterSelected() {
    this.filterCode.next("");
  }

  public get filterEditMode(): boolean {
    return (
      this.filterCode &&
      this.filterCode.value &&
      this.filterCode.value.trim().length > 0 &&
      this.filterSelected &&
      this.filterSelected.value
    );
  }
  public get filterCurrentCode(): string {
    return this.filterCode.value;
  }

onApplyFilter(filter: any) {
  this.filterService.addFilter(filter);
  this.filterService.triggerFilter();


  this.filterCode.next("");
}


  onApplyFilterButtonClick() {
    this.onApplyFilter(this.filterSelected.value);
  }
}
